<template>
  <div class="thermal-trans-roof__table-wrap">
    <!-- header-row -->
    <div class="thermal-roof__table-header-row">
      <div style="width:20%" class="table-headers">Layers</div>
      <div class="table-headers" style="width:60%">Opaque construction - 3 (Door/ Window frame)</div>
      <div class="table-headers last-header" style="width:20%">Thermal resistance</div>
    </div>
    <!-- data-rows -->

    <div v-for="(layerObj, j) in step5B.thermal_trans_doors[doorIndex].layer_arr_obj" :key="layerObj.layer" class="data-row-wrap">
      <!-- <div class="data-field data-label">N</div> -->

      <div class="data-field" style="width:20%">
        <div class="wall-direction">
          <span> {{ layerObj.layer }}</span>
        </div>
      </div>
      <div class="data-field" style="width:40%">
        <v-select v-model="step5B.thermal_trans_doors[doorIndex].layer_arr_obj[j].material_n_resistance" dense outlined placeholder="Select Construction" :items="doorConstructionData" item-text="material" return-object></v-select>
      </div>
      <div class="data-field">
        <div>{{ step5B.thermal_trans_doors[doorIndex].layer_arr_obj[j].material_n_resistance.thermal_resistance || 0 }}</div>
      </div>
    </div>
    <hr />
    <div>
      <v-btn class="ma-2" outlined color="indigo" dense @click="addNewLayer">
        <v-icon left> mdi-plus </v-icon>
        Add new layer
      </v-btn>
      <v-btn class="ma-2" outlined color="red" dense @click="removeLayer">
        <v-icon left> mdi-delete </v-icon>
        layer
      </v-btn>
    </div>
    <div class="step5B__summary">
      <div class="summary-head">Summary:</div>
      <div class="summary-block__wrap">
        <div class="summary-field__row" style="margin-bottom: 8px">
          <div class="sumarry-field__label">
            Total thermal resistance-m<sup>2</sup>.K/W :
          </div>
          <div class="summary-field__value">{{ step5B.thermal_trans_doors[this.doorIndex].total_thermal_resistance }}</div>
        </div>
        <div class="summary-field__row" style="margin-bottom: 8px" :style="{ 'background-color': `#EAF6EA`, color: '#4CAF50', padding: '4px' }">
          <div class="sumarry-field__label">
            Thermal transmittance of Door, W/m<sup>2</sup>K (U-value) :
          </div>
          <div class="summary-field__value">{{ step5B.thermal_trans_doors[this.doorIndex].u_value_door }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LvInput from 'lightvue/input';
import { doorConstructionData } from '@/constant_data/doorWindowConstructionData';
export default {
  components: {
    LvInput,
  },
  props: ['doorIndex'],
  data() {
    return {
      doorConstructionData,
      layersCount: 0,
      totalThermResist: 0,
      uValueDoor: 0,
    };
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step5B: {
      get: function() {
        return this.$store.state.schema.inputs.step5B;
      },
      set: function(step5B) {
        this.$store.dispatch('setStep5B', step5B);
      },
    },
    // doorWindowConstruction() {
    //   return this.$store.state.doorWindowConstruction;
    // },
  },
  beforeUpdate() {
    this.totalThermalResistance();
    this.calcUValueDoor();
  },
  methods: {
    totalThermalResistance() {
      this.totalThermResist = 0;
      for (let i = 0; i <= this.step5B.thermal_trans_doors[this.doorIndex].layer_arr_obj.length - 1; i++) {
        this.totalThermResist = this.totalThermResist + this.step5B.thermal_trans_doors[this.doorIndex].layer_arr_obj[i].material_n_resistance.thermal_resistance;
      }
      this.step5B.thermal_trans_doors[this.doorIndex].total_thermal_resistance = (+this.totalThermResist).toFixed(2);
      // return this.step5B.thermal_trans_doors[this.doorIndex].total_thermal_resistance;
    },
    calcUValueDoor() {
      this.uValueDoor = 0;
      if (this.step5B.thermal_trans_doors[this.doorIndex].total_thermal_resistance === 0 || '') {
        this.step5B.thermal_trans_doors[this.doorIndex].u_value_door = +0;
        // return 0;
      } else {
        this.uValueDoor = 1 / this.step5B.thermal_trans_doors[this.doorIndex].total_thermal_resistance;
        this.step5B.thermal_trans_doors[this.doorIndex].u_value_door = (+this.uValueDoor).toFixed(2);
        // return this.uValueDoor;
      }
    },
    addNewLayer() {
      this.layersCount = this.step5B.thermal_trans_doors[this.doorIndex].layer_arr_obj.length;
      let newLayer = {
        layer: `Layer ${this.layersCount + 1}`,
        material: '',
        thermal_resistance: 0,
        material_n_resistance: '', //{material:'',thermal_resistance:''}
      };
      this.step5B.thermal_trans_doors[this.doorIndex].layer_arr_obj.splice(this.layersCount, 0, newLayer);
    },
    removeLayer() {
      this.layersCount = this.step5B.thermal_trans_doors[this.doorIndex].layer_arr_obj.length;
      if (this.layersCount !== 1) {
        this.step5B.thermal_trans_doors[this.doorIndex].layer_arr_obj.splice(this.layersCount - 1, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.thermal-roof__table-header-row {
  display: flex;
  width: 100%;
  background-color: #dedede;
  justify-content: space-between;
  margin-top: 20px;
  .table-headers {
    color: #343f4b;
    padding: 12px;
    font-size: 16px;
    // width: 33.33%;
    .last-header {
      margin-left: auto;
    }
  }
}

.data-row-wrap {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 8px 12px 4px 12px;
  // align-items: center;
  .data-field {
    // width: 25%;
    flex-wrap: wrap;

    .wall-direction {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    // text-align: center;
  }
}
.step5B__summary {
  margin-top: 10px;
  .summary-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
    margin: 8px 0;
    .summary-block__wrap {
      display: flex;
      flex-direction: column;
      .summary-field__row {
        display: flex;
        justify-content: space-between;
      }
      .summary-field__label {
        font-size: 12px;
        color: #343f4b;
      }
    }
  }
}
.step5B-conclusion-wrap {
  padding: 8px;
  .step5B-conclusion-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
    margin: 0px 0px 8px 0px;
  }
}
.step5B-wfrop-note {
  background-color: #e9f2fa;
  font-style: italic;
  padding: 8px;
  margin: 12px 0px;
}

.step5B-wfrop-conclusion {
  background-color: #b3f5db;
}
</style>
